import moment from 'moment';

// Shared report-visibility rule for patients.
// - Active patients (block false/undefined): always shown.
// - Deactivated within the last N months (by updatedAt): still shown so past
//   active billing periods can be run; callers append a "(deactivated)" tag.
// - Deactivated more than N months ago: hidden (archived) from reports.
// If a deactivated patient has no updatedAt we show it (labeled) rather than
// risk hiding a possibly-recent, still-billable patient.
export const REPORT_DEACTIVATED_MONTHS = 3;

export function isVisibleOnReport(patient, months) {
  if (!patient) return false;
  if (!patient.block) return true;
  if (!patient.updatedAt) return true;
  const cutoff = moment().subtract(months || REPORT_DEACTIVATED_MONTHS, 'months');
  const u = moment(patient.updatedAt);
  return u.isValid() ? u.isAfter(cutoff) : true;
}

export function filterReportPatients(patients, months) {
  return (patients || []).filter(function (p) { return isVisibleOnReport(p, months); });
}

export function deactivatedSuffix(patient) {
  return (patient && patient.block) ? ' (deactivated)' : '';
}
